export type ApiResponse<T = unknown> =
  | { ok: true; data: T }
  | { ok: false; error: { code: string; message: string; details?: unknown } };

export class ApiError extends Error {
  code: string;
  status: number;
  details?: unknown;
  constructor(message: string, code: string, status: number, details?: unknown) {
    super(message);
    this.code = code;
    this.status = status;
    this.details = details;
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
    ...init,
  });
  let body: ApiResponse<T> | null = null;
  try {
    body = (await res.json()) as ApiResponse<T>;
  } catch {
    throw new ApiError('Sunucudan geçersiz yanıt', 'invalid_response', res.status);
  }
  if (!body.ok) {
    throw new ApiError(body.error.message, body.error.code, res.status, body.error.details);
  }
  return body.data;
}

export const api = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body?: unknown) =>
    request<T>(path, { method: 'POST', body: body ? JSON.stringify(body) : undefined }),
  put: <T>(path: string, body?: unknown) =>
    request<T>(path, { method: 'PUT', body: body ? JSON.stringify(body) : undefined }),
  patch: <T>(path: string, body?: unknown) =>
    request<T>(path, { method: 'PATCH', body: body ? JSON.stringify(body) : undefined }),
  del: <T>(path: string) => request<T>(path, { method: 'DELETE' }),
};

// Types mirroring worker responses
export type ApiUser = {
  id: string;
  email: string;
  full_name: string | null;
  platform_role: 'owner' | 'user';
};

export type ApiOrganization = {
  id: string;
  name: string;
  slug: string | null;
  role: 'admin' | 'editor';
  credit_balance: number;
  current_package_id: string | null;
  package_expires_at: number | null;
  trial_ends_at?: number | null;
};

export type ApiPackage = {
  id: string;
  name: string;
  description: string | null;
  price_try_kurus: number | null;
  price_usd_cents: number | null;
  credits: number;
  duration_days: number;
  features_json: string;
  sort_order: number;
};
